import { useState, useEffect } from "react";
import { FiMenu } from "react-icons/fi";
import {
  PiSquaresFourThin,
  PiUserThin,
  PiHouseThin,
  PiFileTextThin,
  PiChatTextThin,
  PiSignOutThin,
  PiCurrencyDollarThin,
  PiBuildingsThin,
  PiQuestionThin,
  PiShareNetworkThin
} from "react-icons/pi";
import "../assets/css/navbar.css";
import main_logo from "../assets/images/main_logo.png";
import { jwtDecode } from "jwt-decode";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 912);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 912);

      if (window.innerWidth > 912) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    { icon: <PiSquaresFourThin />, label: "Dashboard", path: "/dashboard" },
    { icon: <PiHouseThin />, label: "My Portfolio", path: "/portfolio" },
    { icon: <PiCurrencyDollarThin />, label: "Transactions", path: "/transactions" },
    { icon: <PiFileTextThin />, label: "Documents", path: "/documents" },
    { icon: <PiUserThin />, label: "Profile", path: "/profile" },
    { icon: <PiBuildingsThin />, label: "Projects", path: "/projects" },
    { icon: <PiShareNetworkThin />, label: "Refer & Earn", path: "/referandearn" },
    { icon: <PiChatTextThin />, label: "Messages", path: "/messages" },
    { icon: <PiQuestionThin />, label: "Support", path: "/support" },
  ];

  const [usersData, setUsersData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decoded = jwtDecode(token);
      setUsersData(decoded);
    }
  }, []);

  return (

    <aside
      className={`sidebar ${isMobile ? (isOpen ? "active" : "") : ""
        }`}
    >
      <button
        className="menu-btn"
        onClick={() => setIsOpen(true)}
        style={{
          display: isMobile && !isOpen ? "flex" : "none",
        }}
      >
        <FiMenu />
      </button>

      <button
        className="close-btn"
        onClick={() => setIsOpen(false)}
        style={{
          display: isMobile && isOpen ? "flex" : "none",
        }}
      >
        ✕
      </button>

      <div className="sb-brand">
        <div className="sb-logo">
          <div className="sb-icon" title="Lexora Holdings Private Limited">
            <img src={main_logo} className="w-100 h-100" alt="main_logo" />
          </div>
          <div className="sb-name">Lexora Holdings<span>Private Limited</span></div>
        </div>
      </div>

      <div className="sb-investor">
        <div className="sb-investor-name">{usersData?.full_name || "Hariharan"} </div>
        <div className="sb-investor-id">{usersData?.investorId || "LXH-00001"}</div>
      </div>
      <nav className="sidebar-menu">
        <div className="sb-section-label">Main</div>
        {menuItems.map((item, index) => (
          <div key={index}>
            {(item.label === "Messages") && (
              <div className="sb-section-label">Help</div>
            )}
            {(item.label === "Projects") && (
              <div className="sb-section-label">Expolre</div>
            )}
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `menu-item ${isActive ? "active" : ""}`
              }
            >
              <span className="icon">{item.icon}</span>
              <span className="label">{item.label}</span>
              <span className="hover-glow" />
            </NavLink>
          </div>
        ))}
      </nav>

      <div className="sidebar-footer d-center" >
        <button className="logout" onClick={() => setOpenLogoutModal(true)}>
          <PiSignOutThin />
          Sign Out
        </button>
      </div>


      {openLogoutModal && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to sign out?</p>

            <div className="logout-modal-actions">
              <button
                className="logout-cancel-btn"
                onClick={() => setOpenLogoutModal(false)}
              >
                Cancel
              </button>

              <button
                className="logout-confirm-btn"
                onClick={() => {
                  localStorage.removeItem("token");
                  navigate("/");
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </aside >
  );
}

export default NavBar;
